<template>
  <div class="content" v-loading="loading">
    <div class="top">
      <el-button
        style="float:right;"
        size="small"
        type="primary"
        @click="exportWoodsStore"
        >导出数据</el-button
      >
      <!-- <span class="label">所属区域：</span>
      <el-select
        style="width:130px;"
        v-model="province"
        filterable
        size="mini"
        placeholder="省份"
        @change="onChangeProvince"
      >
        <el-option
          v-for="item in provinceList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        style="width:130px;"
        v-model="city"
        filterable
        size="mini"
        placeholder="市"
        @change="onChangeCity"
      >
        <el-option
          v-for="item in cityList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        style="width:130px;"
        v-model="area"
        filterable
        size="mini"
        placeholder="区"
      >
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.name"
          :value="item.areaCode"
        ></el-option>
      </el-select>
 -->
      <!-- <span class="label" style="margin-left:12px">账号状态：</span>
      <el-select
        style="width:130px;"
        v-model="form.pay_type"
        filterable
        size="mini"
        placeholder="全部"
      >
        <el-option label="全部" value="0"></el-option>
        <el-option label="已启用" value="1"></el-option>
        <el-option label="已禁用" value="2"></el-option>
      </el-select> -->
      <span style="margin-top:5px;margin-right:8px;">用户类型:</span>

      <el-select
        size="mini"
        v-model="form.role"
        style="width:140px;margin-right:8px;"
        placeholder="请选择用户类型"
      >
        <el-option label="普通用户" value="0">普通用户</el-option>
        <el-option label="线上商户" value="2">线上用户</el-option>
        <el-option label="BC联盟用户" value="1">BC联盟用户</el-option>
      </el-select>
      <el-input
        style="width:140px;margin-right:8px;"
        v-model="form.id"
        size="mini"
        clearable
        placeholder="输入用户ID"
      ></el-input>
      <el-input
        style="width:200px;margin-right:8px"
        v-model="form.username"
        size="mini"
        clearable
        placeholder="输入用户账号搜索"
      ></el-input>

      <el-button type="primary" size="mini" @click="searchData">搜索</el-button>
    </div>

    <el-table
      :data="tableData"
      class="table"
      max-height="600"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column label="头像" width="100">
        <template slot-scope="scope">
          <img class="avatar" :src="scope.row.wxheadpic" />
        </template>
      </el-table-column>
      <el-table-column
        prop="wxnickname"
        label="昵称"
        width="140"
      ></el-table-column>
      <!-- <el-table-column
        prop="username"
        label="用户名"
        width="140"
      ></el-table-column> -->
      <el-table-column label="用户区域">
        <template slot-scope="scope">
          {{
            scope.row.third_wechat
              ? scope.row.third_wechat.province
              : scope.row.province
          }}
          {{
            scope.row.third_wechat
              ? scope.row.third_wechat.city
              : scope.row.city
          }}
          {{ scope.row.area }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="status" label="账号状态" width="120">
        <template slot-scope="scope">
          <el-switch
            style="margin-right:8px"
            :key="scope.row.id"
            :active-value="1"
            :inactive-value="0"
            :value="scope.row.status"
            @change="onSwitchChange(scope.row, $event)"
          ></el-switch
          >{{ Number(scope.row.status) === 1 ? '开启' : '禁用' }}
        </template>
      </el-table-column> -->
      <el-table-column label="用户类型">
        <template slot-scope="scope">
          <p v-if="scope.row.role == 0">普通用户</p>
          <p v-if="scope.row.role == 2">线上用户</p>
          <p v-if="scope.row.role == 1">BC联盟用户</p>
        </template>
      </el-table-column>
      <el-table-column label="可用红包" width="140">
        <template slot-scope="scope">{{
          scope.row.red_picket ? scope.row.red_picket.balance_tlj : '0.00'
        }}</template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="160">
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="450">
        <template slot-scope="scope">
          <el-button
            size="mini"
            class="btn"
            v-if="scope.row.black_list_stats == 2"
            @click="frozen(scope.row.mobile)"
            >冻结</el-button
          >
          <el-button
            size="mini"
            class="btn"
            v-if="scope.row.black_list_stats == 1"
            @click="thaw(scope.row.mobile)"
            >解冻</el-button
          >
          <el-button size="mini" class="btn" @click="removeCard(scope.row.id)"
            >绑卡解封</el-button
          >
          <el-button size="mini" class="btn" @click="removeBind(scope.row.id)"
            >解绑手机号</el-button
          >
          <el-button size="mini" class="btn" @click="onDetailClick(scope.row)"
            >用户信息</el-button
          >
          <el-button
            size="mini"
            class="btn"
            @click="onRechargeClick(scope.row.mobile)"
            >充值红包</el-button
          >
          <el-button
            size="mini"
            class="btn"
            @click="onPakcketRecord(scope.row.mobile, '0')"
            >红包充值记录</el-button
          >
          <el-button
            size="mini"
            class="btn"
            @click="onPakcketRecord(scope.row.mobile, '1')"
            >红包使用记录</el-button
          >
          <el-button
            size="mini"
            class="btn"
            @click="deductPakcket(scope.row.id)"
            >扣除红包</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>

    <!-- <UserInfoDialog :visible.sync="detailDialogVisible" :id="tempId" type="1" /> -->

    <jdialog
      title="用户基本信息"
      :visible.sync="showUserBaseInfo"
      width="640px"
    >
      <div style="float:left;width:50%;padding:20px;">
        <div style="padding:10px;">
          <span class="base_info">用户ID:</span><span>{{ userForm.id }}</span>
        </div>
        <!-- <div style="padding:10px;">
          <span class="base_info">用户名:</span
          ><span>{{ userForm.username }}</span>
        </div> -->
        <div style="padding:10px;">
          <span class="base_info">Openid:</span
          ><span>{{ userForm.openid }}</span>
        </div>
      </div>
      <div style="float:left;width:50%;padding:20px;">
        <div style="padding:10px;">
          <span class="base_info">创建时间:</span
          ><span>{{ userForm.create_time }}</span>
        </div>
        <div style="padding:10px;">
          <span class="base_info">用户区域:</span
          ><span
            >{{ userForm.province }}.{{ userForm.city }}.{{
              userForm.area
            }}</span
          >
        </div>
        <div style="padding:10px;">
          <span class="base_info">会员身份:</span>
          <span v-if="userForm.role == 0">普通用户</span>
          <span v-if="userForm.role == 2">线上用户</span>
          <span v-if="userForm.role == 1">BC联盟用户</span>
        </div>
      </div>
    </jdialog>

    <jdialog
      title="充值红包"
      :visible.sync="rechargeDialogVisible"
      width="640px"
    >
      <div class="recharge-box" v-loading="rechargeDialogLoading">
        <p class="tip">
          提示：红包充值成功后，账号中对应增加充值金额，已充值红包不可回收
        </p>
        <el-form
          :model="rechargeForm"
          :rules="rechargeRule"
          label-width="100px"
          ref="rechargeForm"
        >
          <el-form-item label="充值金额：" prop="money">
            <el-input
              class="input-hb"
              v-model="rechargeForm.money"
              type="number"
              min="0"
              placeholder="输入红包充值金额"
            >
            </el-input>
            <span>元</span>
          </el-form-item>
          <el-form-item label="输入密码：" prop="password">
            <el-input
              size="mini"
              v-model="rechargeForm.password"
              type="password"
              style="width:120px;"
            ></el-input>
          </el-form-item>
          <el-form-item class="btns">
            <el-button type="primary" @click="onConfirmRecharge"
              >确定</el-button
            >
            <el-button type="info" @click="rechargeDialogVisible = false"
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </jdialog>

    <jdialog title="扣除红包" :visible.sync="deductPakcketFlag" width="640px">
      <div class="recharge-box">
        <el-form
          :model="deductForm"
          :rules="deductFormRule"
          label-width="140px"
          ref="deductForm"
        >
          <el-form-item label="扣除红包金额：" prop="deduct">
            <el-input
              class="input-hb"
              v-model="deductForm.deduct"
              type="number"
              min="0"
              placeholder="输入扣除红包金额"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="扣除类型：" prop="source_from">
            <el-select
              v-model="deductForm.source_from"
              placeholder="请选择扣除类型"
            >
              <el-option
                :label="item.type_name"
                :value="item.type"
                v-for="(item, index) in sourceSelect"
                :key="index"
                >{{ item.type_name }}</el-option
              >
            </el-select>
          </el-form-item>
          <el-form-item class="btns" style="margin-left:0;">
            <el-button type="primary" @click="onConfirmDeduct">确定</el-button>
            <el-button
              type="info"
              @click="
                deductPakcketFlag = false
                deductForm = {
                  id: '',
                  source_from: '',
                  deduct: ''
                }
              "
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </jdialog>
  </div>
</template>

<script>
import {
  getNormalUserNew,
  getUserDetail,
  rechargeHb,
  removeMobile,
  removeCard,
  frozen,
  thaw,
  confirmDeduct
} from '@/api/managent'
import { API_BASE_URL } from '@/config'
// import { provinceCityArea } from '@/api/goods'
// import UserInfoDialog from './userInfoDialog'
export default {
  // components: { UserInfoDialog },
  data() {
    return {
      loading: false,
      detailDialogVisible: false,
      province: '',
      city: '',
      area: '',
      form: {
        username:'',
        id: '',
        role: '',
        is_export: 0,
        // adcode: '',
        page: 1,
        size: 20
      },
      provinceList: [],
      cityList: [],
      areaList: [],
      tableData: [],
      tempId: '',
      total: 0,

      //用户基本信息
      showUserBaseInfo: false,
      userForm: {
        id: '',
        username: '',
        openid: '--',
        create_time: '',
        province: '',
        city: '',
        area: '',
        role: ''
      },

      //用户充值红包
      rechargeDialogVisible: false,
      rechargeDialogLoading: false,
      rechargeForm: {
        money: 0,
        mobile: '',
        password: ''
      },
      rechargeRule: {
        money: [
          { required: true, message: '输入红包充值金额', trigger: 'blur' }
        ],
        password: [{ required: true, message: '输入密码', trigger: 'blur' }]
      },
      deductPakcketFlag: false,
      deductForm: {
        id: '',
        source_from: '',
        deduct: ''
      },
      sourceSelect: {},
      deductFormRule: {
        deduct: [
          { required: true, message: '请输入扣除红包金额', trigger: 'blur' }
        ],
        source_from: [
          { required: true, message: '请选择扣除类型', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {},
  created() {
    // this.getProvinceDataList('1', '0')
    this.getListData()
  },
  methods: {
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    },
    // 导出数据
    exportWoodsStore() {
      this.form.is_export = 1
      this.getListData()
    },
    //搜索
    searchData() {
      this.getListData()
    },

    pageChange(page) {
      this.form.page = page
      this.getListData()
    },
    //获取小店列表
    getListData() {
      getNormalUserNew(this.form).then(res => {
        if (res.code === 10000) {
          if (this.form.is_export === 1) {
            this.form.is_export = 0
            window.open(
              `${API_BASE_URL}/admin/download/zip/${res.data.download_token}`
            )
            return
          } else {
            this.tableData = res.data.data || []
            this.total = res.data.total
            this.sourceSelect = res.data.source_from
          }
        } else {
          this.form.is_export = 0
          this.$message.error(res.message)
        }
        this.loading = false
      })
    },

    onSwitchChange(item, e) {
      item.status = e
    },
    onPakcketRecord(mobile, type) {
      this.$router.push({
        path: './userRedList',
        query: {
          mobile: mobile,
          type: type
        }
      })
    },

    async onDetailClick(row) {
      // this.tempId = id
      // this.detailDialogVisible = true
      const detailRes = await getUserDetail(
        row.id ? { uid: row.id } : { mobile: row.mobile }
      )
      if (detailRes.code === 10000) {
        if (detailRes.data.wechat) {
          this.userForm.openid = detailRes.data.wechat.mini_openid
        }

        this.userForm.create_time = detailRes.data.create_time
        this.userForm.id = row.id
        this.userForm.username = detailRes.data.username
        this.userForm.province = detailRes.data.wechat
          ? detailRes.data.wechat.province
          : detailRes.data.province

        this.userForm.city = detailRes.data.wechat
          ? detailRes.data.wechat.city
          : detailRes.data.city

        this.userForm.area = detailRes.data.area
        this.userForm.role = row.role
        this.showUserBaseInfo = true
      } else {
        this.$message.error(detailRes.message)
      }
    },
    onRechargeClick(mobile) {
      this.rechargeForm.mobile = mobile
      this.rechargeDialogVisible = true
    },
    onConfirmRecharge() {
      if (this.rechargeForm.money < 0) {
        this.$message({
          showClose: true,
          message: '充值金额需大于0',
          type: 'error'
        })
        return false
      }
      this.$refs.rechargeForm.validate(valid => {
        if (valid) {
          this.rechargeDialogLoading = true
          rechargeHb(this.rechargeForm).then(res => {
            if (res.code === 10000) {
              this.$message.success('充值成功')
              this.rechargeDialogVisible = false
              this.detailDialogVisible = false
              this.form.page = 1
              this.getListData()
            } else {
              this.$message.error(res.message)
            }
            this.rechargeDialogLoading = false
          })
        } else {
          return false
        }
      })
    },
    deductPakcket(id) {
      this.deductPakcketFlag = true
      this.deductForm.id = id
    },
    onConfirmDeduct() {
      if (this.deductForm.deduct < 0) {
        this.$message({
          showClose: true,
          message: '红包金额需大于0',
          type: 'error'
        })
        return false
      }
      this.$refs.deductForm.validate(valid => {
        console.log(valid)
        if (valid) {
          confirmDeduct(this.deductForm)
            .then(res => {
              console.log(res)
              if (res.code === 10000) {
                this.$message.success(res.message)
              } else {
                this.$message.error(res.message)
              }
              this.getListData()
              this.deductPakcketFlag = false
              this.deductForm = {
                id: '',
                source_from: '',
                deduct: ''
              }
            })
            .catch(err => {
              this.$message.error(err)
            })
          console.log(this.deductForm)
        } else {
          return false
        }
      })
    },
    // 解除绑定手机号
    removeBind(id) {
      removeMobile({ id: id }).then(res => {
        if (res.code === 10000) {
          this.getListData()
          this.$message.success('解除成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 绑卡解封
    removeCard(id) {
      removeCard({ id: id }).then(res => {
        if (res.code === 10000) {
          this.getListData()
          this.$message.success('解封成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 冻结
    frozen(mobile) {
      frozen({ mobile: mobile }).then(res => {
        if (res.code === 10000) {
          this.getListData()
          this.$message.success('冻结成功')
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 解冻
    thaw(mobile) {
      thaw({ mobile: mobile }).then(res => {
        if (res.code === 10000) {
          this.getListData()
          this.$message.success('解冻成功')
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 20px;
  .btn {
    margin: 4px;
  }
  .top {
    margin-bottom: 20px;
  }
  .table {
    width: 100%;
    // padding: 20px 20px;
    margin: 20px 0;
    .avatar {
      width: 48px;
      height: 48px;
      object-fit: cover;
    }
  }
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .base_info {
    color: #666;
    margin: 0 8px 0 12px;
  }
  .recharge-box {
    padding-top: 30px;
    .tip {
      margin: 16px;
    }
    .input-hb {
      width: 400px;
      margin-right: 12px;
    }
    .btns {
      margin-right: 150px;
      margin-top: 50px;
      margin-bottom: 20px;
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>
